export const gnavHeaderId = "gnav-main-container"

export const gnavFooterId = "gnav-footer-container"
